import { api } from '@shared/api/api';

type TimeTrackingGroup = App.Domain.TimeTracking.Data.TimeTrackingGroupData;

export type CreateTimeTrackingGroupData = App.Http.Requests.TimeTracking.CreateTimeTrackingGroupData;

export const createTimeTrackingGroup = api.createCreate<CreateTimeTrackingGroupData, TimeTrackingGroup>(
  'time-tracking-groups'
);
